import ResourceGet from '../../resource/get';

const AssetsGet = () => {

      return(
        <div>
          <ResourceGet resource="templates" name="Templates" />
        </div>
      )

}

export default AssetsGet;